module.exports = __webpack_public_path__ + "img/iatalogo.cf822eef.png";